import axios from 'axios';
import { toast } from 'react-toastify';

import { USER_ACCESS_TOKEN } from 'shared/constants/localstorage';
import { convertKeysToCamelCase } from 'shared/utils/converRequestAndresponseData';

const apiUrl =
  process.env.REACT_APP_RE_MATCH_API ||
  `${window.location.protocol}//api.${window.location.hostname}`;

export const $api = axios.create({
  baseURL: apiUrl,
});

$api.interceptors.request.use((config) => {
  const newConfig = { ...config };
  newConfig.url = config.url;

  if (newConfig.headers) {
    const token = localStorage.getItem(USER_ACCESS_TOKEN);
    if (token) {
      newConfig.headers.Authorization = `Bearer ${token}`;
    } else {
      console.warn(
        'No access token found in localStorage for API request to:',
        config.url,
      );
    }
  }

  return newConfig;
});

$api.interceptors.response.use(
  (response) => {
    if (response.data && response.config.responseType !== 'blob') {
      response.data = convertKeysToCamelCase(response.data);
    }

    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      toast('Session expired');
    } else if (error?.request) {
      console.error('Network Error - No response received:', {
        url: error?.config?.url,
        message: error?.message,
      });
    }

    return Promise.reject(error);
  },
);

export default $api;
